import { Epic } from 'redux-observable';
import { of, from } from 'rxjs';
import { mergeMap, map, catchError, filter } from 'rxjs/operators';
import { RootState } from '../store';
import { getPropensityPredictions } from '@/services/api';
import {
  FETCH_PROPENSITY_PREDICTIONS_REQUESTED,
  fetchPredictionsSucceeded,
  fetchPredictionsFailed,
  setPropensityLoading,
  setPropensityError,
  setPropensityData
} from '../slices/propensitySlice';

export const fetchPropensityPredictionsEpic: Epic<any, any, RootState> = (action$, state$) =>
  action$.pipe(
    filter((action: any) => action.type === FETCH_PROPENSITY_PREDICTIONS_REQUESTED),
    mergeMap((action: any) => {
      const { limit, offset, search } = action.payload || {};
      // Ensure we always pass a string (backend expects empty string when no search)
      const searchParam = typeof search === 'string' ? search : '';
      return from(getPropensityPredictions({ limit, offset, search: searchParam })).pipe(
        map((response) => fetchPredictionsSucceeded(response)),
        catchError((error) => of(fetchPredictionsFailed(error.message || 'Failed to fetch propensity predictions')))
      );
    })
  );

export const handlePropensityPredictionsSuccessEpic: Epic<any, any, RootState> = (action$) =>
  action$.pipe(
    filter((action: any) => action.type === 'propensity/FETCH_PREDICTIONS_SUCCEEDED'),
    mergeMap((action: any) => {
      return of(
        setPropensityData(action.payload),
        setPropensityLoading(false),
        setPropensityError(null)
      );
    })
  );

export const handlePropensityPredictionsFailureEpic: Epic<any, any, RootState> = (action$) =>
  action$.pipe(
    filter((action: any) => action.type === 'propensity/FETCH_PREDICTIONS_FAILED'),
    mergeMap((action: any) => {
      return of(
        setPropensityError(action.payload),
        setPropensityLoading(false)
      );
    })
  );

export const propensityEpics = [
  fetchPropensityPredictionsEpic,
  handlePropensityPredictionsSuccessEpic,
  handlePropensityPredictionsFailureEpic
];

export default propensityEpics;


